// External libraries
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';

// Internal imports - state
import { store } from 'src/state/dynamic-store';
import { RootState } from '@state/root-state.ts';

// Internal imports - components
import { SalutationsComponentWrapper } from '@sharedComponents/salutations/SalutationsComponent';
import { CdfBreadcrumbs } from '@commonComponents/navigation/CdfBreadcrumbs';

// Styles
import styles from './SalutationsPage.module.scss';

export function SalutationsPage() {
  const { t } = useTranslation(['layouts']);
  const organizationId = useSelector((state: RootState) => state.appContext.selectedOrganizationId) ?? '';

  return (
    <>
      <CdfBreadcrumbs items={[{ label: t('breadCrumbs.salutations.page') }]} />
      <Paper className={styles.container}>
        <SalutationsComponentWrapper organizationId={organizationId} store={store} />
      </Paper>
    </>
  );
}
